<template>
    <div>
        <div class="container table-responsive bg-light p-2">
            <button class="btn-close float-end mt-3 me-3" @click.prevent="closeList"></button>
            <h3 class="mx-auto my-3 ">Clasificación de {{ sendTubeInfo.tubeName }} / {{
                sendTubeInfo.tubeSpecification }}</h3>
            <table class="table table-hover table-bordered my-1">
                <thead>
                    <tr>
                        <th scope="col">Nombre comercial</th>
                        <th scope="col">Nombre técnico</th>
                        <th scope="col">Diámetro/Dimensión exterior en mm</th>
                        <th scope="col">Espesor pared en mm</th>
                        <th scope="col">Peso por metro</th>
                        <th scope="col">Precio Oxicorte</th>
                        <!-- <th scope="col">Precio Corte Plasma</th>
                        <th scope="col">Precio Corte Laser</th> -->
                        <th scope="col">Precio Sold. Elect.</th>
                        <th scope="col">Precio Sold. Mig</th>
                        <th scope="col">Precio rolado (Base/Canto)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="tube in tubes" :key="tube.id">
                        <th scope="row">
                        <td>{{ tube.tradeName }}</td>
                        </th>
                        <td>{{ tube.technicalName }}</td>
                        <td>{{ tube.diameterOrDimensionMm }}</td>
                        <td>{{ tube.thicknessWall }}</td>
                        <td>{{ tube.weightMeter }}</td>
                        <td>{{ tube.priceFlameCutting }}</td>
                        <!-- <td>{{ tube.pricePlasmaCutting }}</td>
                        <td>{{ tube.priceLaserCutting }}</td> -->
                        <td>{{ tube.priceWeldingElectrode }}</td>
                        <td>{{ tube.priceWeldingMig }}</td>
                        <td>{{ tube.priceRolled }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        sendTubeInfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tubes: [],
        };
    },
    watch: {
        sendTubeInfo(newVal) {
            if (newVal !== null) {
                this.getTubeTypes();
            }
        },
    },
    methods: {
        closeList() {
            this.$emit("close-list")
        },
        async getTubeTypes() {
            try {
                if (!this.sendTubeInfo.tubeId) {
                    console.log("Tube type id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/tube/type/list", {
                    params: {
                        tube_main_id: this.sendTubeInfo.tubeId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                })
                    .then((res) => (this.tubes = res.data, console.log(this.tubes)))
                    .catch((err) => console.log(`There has been an error ${err}`));
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
    },
    mounted() {
        // console.log(this.sendSheetInfo);
        this.getTubeTypes();
    },
};
</script>